module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second-white.c314a754.png";